import { render, staticRenderFns } from "./SettingShare.vue?vue&type=template&id=4b15463d&scoped=true"
import script from "./SettingShare.vue?vue&type=script&lang=js"
export * from "./SettingShare.vue?vue&type=script&lang=js"
import style0 from "./SettingShare.vue?vue&type=style&index=0&id=4b15463d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b15463d",
  null
  
)

export default component.exports